"use client";

import { ColorModeContext } from "@contexts/color-mode";
import { useContext } from "react";

export const AuthLayout = ({ children }: React.PropsWithChildren) => {
  const { mode } = useContext(ColorModeContext);

  return (
    <div
      className="relative grid min-h-screen bg-background text-foreground lg:grid-cols-2"
      style={{
        background:
          mode === "dark"
            ? `linear-gradient(to top, color-mix(in srgb, var(--primary-club) 20%, transparent) 0%, hsl(var(--background)) 70%)`
            : `linear-gradient(to top, color-mix(in srgb, var(--primary-club) 31%, transparent) 0%, hsl(var(--background)) 70%)`,
      }}
    >
      {children}
    </div>
  );
};
